import { render, staticRenderFns } from "./TabBlendShape.vue?vue&type=template&id=51400f4e&scoped=true&"
import script from "./TabBlendShape.vue?vue&type=script&lang=ts&"
export * from "./TabBlendShape.vue?vue&type=script&lang=ts&"
import style0 from "./TabBlendShape.vue?vue&type=style&index=0&id=51400f4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51400f4e",
  null
  
)

export default component.exports